import React from 'react'
import DataSource from '../DataSource'
import BroadbandContainer from '../components/BroadbandContainer'
import Module from '../modules/Module'
import ExpandableListModule from '../modules/ExpandableListModule'
import FreeShipping from '../components/FreeShipping'
import MobileFeatures from './MobileFeatures'
import globals from '../globals'
import BannerMobile from '../banners/BannerMobile'
import ComparePlansMobile from '../components/ComparePlansMobile'
import SideBgRight from '../components/SideBgRight'
import SideBgLeft from '../components/SideBgLeft'
import MobileSlashBillBox from '../components/MobileSlashBillBox'
import { gsap } from 'gsap'
import { appendAgentTokenInput } from '../utils/agentUtil'
import { appendGenesysIdInput } from '../utils/addGenesysId'
import { appendUtmSourceId } from '../utils/utmUtil'

class Mobile4GPlans extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            isLoaded: false,
            title: '',
            subHeading: '',
            needToKnow: [],
            plans: [],
            currentPlan: {},
            error: false,
            errorMessage: ''
        }
    }

    componentDidMount () {
        this.getContent()
        this.getPlans()
    }

    getContent () {
        DataSource.getData('/api/getContent/mobile/plans', response => {
            this.setState({ ...response })
        })
    }

    getPlans () {
        const onSuccess = (response) => {
            this.setState({
                plans: response.data.plans,
                currentPlan: response.data.plans[4],
                isLoaded: true
            })
        }

        const onFailure = (error) => {
            this.setState({
                isLoaded: true,
                error: true,
                errorMessage: error
            })
        }

        DataSource.getMobilePlans(onSuccess, onFailure)
    }

    handleClickBuyNow (event, planId) {
        event.preventDefault()
        event.stopPropagation()
        this.state.plans.forEach(plan => {
            if (plan.id === planId) {
                this.setState({ currentPlan: plan }, () => {
                    globals.pushGA4Events('mobileOrderNowResi', {
                        eventInfo: {
                            planName: this.state.currentPlan.title + " " + this.state.currentPlan.data,
                            totalPrice: this.state.currentPlan.price,
                            orderType: this.state.currentPlan.subHeading,
                            pageCategory: 'Residential'
                        }
                    })
                    globals.pushGA4Events('select_item', {
                        eccommerce: {
                            currency: "aud",
                            value: this.state.currentPlan.price,
                            items: [
                                {
                                    item_name: this.state.currentPlan.title + " " + this.state.currentPlan.data,
                                    item_category: 'Residential',
                                    item_category2: 'Mobile',
                                    item_category3: this.state.currentPlan.subHeading.replace(' Plan', ''),
                                    price: this.state.currentPlan.price,
                                    currency: "aud",
                                    quantity: 1
                                }
                            ]
                        }
                    })
                    this.handleSubmitOrder(planId)
                })
            }
        })
    }

    handleSubmitOrder (planId) {
        const form = document.createElement('form')
        const data = {
            type: 'mobile',
            plan_id: planId,
            contract_term: 0
        }

        Object.keys(data).map((key) => {
            const input = document.createElement('input')
            input.name = key
            input.type = 'hidden'
            input.value = data[key]
            form.appendChild(input)
        })

        appendAgentTokenInput(form)
        appendUtmSourceId(form)
        appendGenesysIdInput(form)

        form.method = 'GET'
        form.action = 'https://staging.order.exetel.com.au/'
        if (process.env.NODE_ENV === 'production') {
            form.action = 'https://order.exetel.com.au'
        }

        this.pushOrderEvent()
        document.body.appendChild(form)
        form.submit()
    }

    pushOrderEvent () {
        globals.pushEvent('gtm-Mobile-OrderStart', {
            data: this.state.currentPlan.data,
            price: this.state.currentPlan.price,
            title: this.state.currentPlan.title
        })
    }

    scrollTo (event) {
        event.preventDefault()
        gsap.to(window, {
            duration: 1,
            scrollTo: {
                y: document.querySelector('.terms-anchor'),
                offsetY: 140
            }
        })
    };

    render () {
        return (
            <div id='mobile4gPlans'>
                <BannerMobile />
                <BroadbandContainer isLoaded={this.state.isLoaded} showOverlay={false} className='mobile-plans-container'>
                    <div className='inner-container'>
                        <div className='row mx-lg-2 mt-lg-5 mt-3 no-gutters px-lg-3'>
                            <div className='col-12'>
                                <div className='row mr-auto ml-auto mb-5 mobile-content-row'>
                                    <MobileSlashBillBox className='flex-4' show imgUrl='/images/slash-my-bill.svg'>
                                        <p className='text-left p-4 m-0 font-smaller'>
                                            With our SLASH MY BILL discounts, the more products you bundle with exetel, the more you save. SLASH UP TO $15 OFF your monthly Exetel broadband bill when you purchase additional eligible Exetel services such as a new Mobile SIM plan or a Home Phone plan. To learn more see <a className='color-lime semi-bold' onClick={this.scrollTo.bind(this)} style={{ cursor: 'pointer' }}>Things you need to know</a>.
                                        </p>
                                    </MobileSlashBillBox>
                                </div>
                                <div className='d-flex ml-auto mr-auto mb-3 '>
                                    <h2 className='m-0 text-left font-nlarge' dangerouslySetInnerHTML={{ __html: `${globals.noWidows('Choose your mobile SIM plan')}` }} />
                                </div>
                                <div className='d-flex justify-content-center'>
                                    <ComparePlansMobile
                                        plans={this.state.plans}
                                        selectedPlan={this.state.currentPlan}
                                        handleClickBuyNow={this.handleClickBuyNow.bind(this)}
                                    />
                                </div>
                                <div className='d-flex flex-column justify-content-center align-items-center mt-4'>
                                    <a className="mt-2 color-grey-500 underline font-small" href="https://files.exetel.com.au/cis/mobile/2025-01-23/Exetel_Prepaid_Mobile_CIS.pdf" target='_blank' rel='noopener noreferrer'>Exetel Residential Mobile Voice Critical Information Summary</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='side-bg-left'>
                        <SideBgLeft />
                    </div>
                    <div className='side-bg-right'>
                        <SideBgRight />
                    </div>
                    <FreeShipping />
                    <MobileFeatures />
                    <Module className='bg-lightgrey terms-anchor' id='things-to-know'>
                        <ExpandableListModule title='Things you need to know' data={this.state.needToKnow} hasPadding={false} ukraine />
                    </Module>
                </BroadbandContainer>
            </div>
        )
    }
}

export default Mobile4GPlans



// WEBPACK FOOTER //
// ./resources/js/mobile/Mobile4GPlans.js